<div mdbModal #editarPrecioCosto="mdb-modal" class="modal fade" id="basicExamplex" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <form [formGroup]="formPrecioCosto" (ngSubmit)="guardarPrecioCosto();">
                <div class="modal-header">
                    <h4 class="modal-title w-100 text-left" id="myModalLabel">Editar Precio Costo</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="editarPrecioCosto.hide()"><span aria-hidden="true">×</span></button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <div class="col" style="max-width: 200px;">
                                <div class="md-form" style="display: flex; align-items: center;">
                                    <strong>Precio de costo Actual $ {{ precioCostoOriginal }}</strong>
                                </div>
                                <div>
                                    <label for="pprecio">Nuevo Precio Costo<span class="text-danger"></span></label>
                                    <input value="" formControlName="precio" type="number" id="pprecio"
                                        class="form-control" placeholder="0,00" maxLength="50" step="0.1" #pvolumen />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-sm btn-default waves-light" size="sm"  data-dismiss="modal"
                        (click)="editarPrecioCosto.hide()" mdbWavesEffect>Cerrar</button>
                    <button type="submit" class="btn btn-sm btn-secondary waves-light" size="sm" mdbWavesEffect>Guardar</button>
                </div>
            </form>
        </div>
    </div>
</div>

<app-modal-confirm></app-modal-confirm>